import { useEffect, useState } from 'react';
import noop from 'lodash/noop';
import env from '@y2/environments';
import { analytics } from '@y2/google-tag-manager/v2';
import { Button } from '@y2/mango/components/button';
import { Modal } from '@y2/mango/components/modal';
import { cookie } from '@y2/packages-utils/cookies';

import styles from './cookie-implementation-disclaimer.module.scss';
import text from './cookie-implementation-disclaimer.text.json';
import { CookieImplementationInfoSection } from '../info-section/cookie-implementation-info-section';
import { CookieImplementationTitle } from '../title/cookie-implementation-title';

const COOKIE_KEY = 'cookie-implementation-disclaimer-consent';

export const getDomain = () => {
  const isLocalhost = window.location.hostname === 'localhost';

  return isLocalhost
    ? 'localhost'
    : env.routes.mainSite.replace('https://www', '');
};

export const CookieImplementationDisclaimer = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const consentedFromCookie = cookie.get(COOKIE_KEY);

    if (!consentedFromCookie) {
      setIsOpen(true);
    }
  }, []);

  const handleConsent = () => {
    // eslint-disable-next-line no-magic-numbers
    const oneYearFromNow = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);
    cookie.set(COOKIE_KEY, '1', {
      path: '/',
      domain: getDomain(),
      secure: true,
      expires: oneYearFromNow,
    });
    setIsOpen(false);
    analytics.pushEvent({
      EventName: 'cookie_accept',
      EventDetail: 'cookie_banner',
      EventText: text.understand,
      EventGroup: 'browsing_interactions',
    });
  };

  return (
    <Modal
      open={isOpen}
      onClose={noop}
      label={text.label}
      description={text.description}
      data-nagish="cookie-implementation-disclaimer"
      data-testid="cookie-implementation-disclaimer"
      hasDefaultFrame={false}
      shouldDisableScroll={false}
      hasCloseButton={false}
      mobileBehavior="drawer"
      className={styles.popupContent}
      classNameRoot={styles.popupRoot}
    >
      <div className={styles.content}>
        <CookieImplementationTitle />
        <CookieImplementationInfoSection />
        <div className={styles.actions}>
          <Button
            variant="primary"
            height="small"
            onClick={handleConsent}
            className={styles.submitButton}
            data-testid="cookie-implementation-disclaimer-submit-button"
          >
            {text.understand}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
